import * as actionTypes from "../actions/actionTypes";

const initialState = {
  otpSpinnerProcessing: false,
  genTokenResponse: null,
  disableConfirm: false,
  generateOtpMessage: null,
  tempGenerateOtpMessage: null,
  otpGenerated: false,
  verifyOtpTmxMessage: null,
  verifyOtpMessage: null,
  isDbicDoneBefore: false,
  expiredLinkMessage: null,
  idverseResult: false,
  dbicState: "",
  dbicData: null,
  enableAttest: "",
  reuseFlow: false,
  pollTimeout: false,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SMS_OTP_TOKEN_LOADER_IC:
      return {
        ...state,
        otpSpinnerProcessing: !state.otpSpinnerProcessing,
      };
    case actionTypes.SMS_OTP_TOKEN_SUCCESS_IC:
      return {
        ...state,
        genTokenResponse: action.genTokenResponse,
        disableConfirm: false,
        ...(action.origin
          ? {
            tempGenerateOtpMessage: {
              type: "Success",
              info: {
                message:
                  action.otpType === "Phone"
                    ? "Passcode Sent"
                    : "Passcode Call Initiated",
              },
            },
          }
          : {
            generateOtpMessage: {
              type: "Success",
              info: {
                message:
                  action.otpType === "Phone"
                    ? "Passcode Sent"
                    : "Passcode Call Initiated",
              },
            },
          }),
        verifyOtpMessage: state.verifyOtpMessage?.type === "Error" && state.verifyOtpMessage?.info?.message?.includes("locked") ? null : state.verifyOtpMessage,
      };
    case actionTypes.SMS_OTP_TOKEN_FAILURE_IC:
      return {
        ...state,
        ...(action.origin
          ? {
            tempGenerateOtpMessage: {
              type: "Error",
              info: { message: action.error },
            },
          }
          : {
            generateOtpMessage: {
              type: "Error",
              info: { message: action.error },
            },
          }),
        verifyOtpMessage: state.verifyOtpMessage?.type === "Error" && state.verifyOtpMessage?.info?.message?.includes("locked") ? null : state.verifyOtpMessage,
      };
    case actionTypes.OTP_GENERATED_FLAG_IC:
      return {
        ...state,
        otpGenerated: action.flag,
      };
    case actionTypes.OTP_GENERATED_MESSAGE_RESET_IC:
      return {
        ...state,
        generateOtpMessage: null,
        tempGenerateOtpMessage: null,
        verifyOtpTmxMessage: null,
        verifyOtpMessage: null,
        genTokenResponse: null,
        isDbicDoneBefore: false,
        dbicState: "",
        dbicData: null,
      };
    case actionTypes.TEMP_GENERATE_OTP_MESSAGE_RESET_IC:
      return {
        ...state,
        tempGenerateOtpMessage: null,
      };
    // verify flow
    case actionTypes.VERIFY_OTP_TOKEN_SUCCESS_IC:
      return {
        ...state,
        persInfoMsg: null,
        verifyOtpTmxMessage: {
          type: "Success",
          info: { message: action.tmxMessage },
        },
        verifyOtpMessage: {
          type: "Success",
          info: { message: action.otpMessage },
        },
      };
    case actionTypes.VERIFY_OTP_TOKEN_FAILURE_IC:
      return {
        ...state,
        verifyOtpTmxMessage: action.error
          ? { type: "Error", info: { message: action.error } }
          : null,
        verifyOtpMessage: {
          type: action.error ? "Success" : "Error",
          info: { message: action.otpMessage },
        },
      };
    case actionTypes.SEND_DBIC_LINK_SUCCESS_IC:
      return {
        ...state,
        sendDbicLinkMessage: {
          type: "Success",
          info: { message: action.message },
        },
        dbicData: action.dbicData,
        dbicState: "pending",
        reuseFlow: false,
      };
    case actionTypes.SEND_DBIC_LINK_FAILURE_IC:
      return {
        ...state,
        sendDbicLinkMessage: action.error
          ? { type: "Error", info: { message: action.error } }
          : null,
        dbicData: null,
        reuseFlow: false,
      };
    case actionTypes.RESEND_DBIC_LINK_SUCCESS_IC:
      return {
        ...state,
        reSendDbicLinkMessage: {
          type: "Success",
          info: { message: action.message },
        },
      };
    case actionTypes.RESEND_DBIC_LINK_FAILURE_IC:
      return {
        ...state,
        reSendDbicLinkMessage: action.error
          ? { type: "Error", info: { message: action.error } }
          : null,
      };
    case actionTypes.RESET_RESEND_DBIC_LINK_MESSAGE_IC:
      return {
        ...state,
        reSendDbicLinkMessage: null,
      };
    case actionTypes.RESET_SEND_DBIC_LINK_MESSAGE_IC:
      return {
        ...state,
        sendDbicLinkMessage: null,
      };
    case actionTypes.DBIC_POLLING_SUCCESS_IC:
      return {
        ...state,
        dbicState: "success",
        pollTimeout: false,
      };
    case actionTypes.DBIC_POLLING_FAILURE_IC:
      return {
        ...state,
        dbicState: "failure",
        pollTimeout: action.timeout,
      };
    case actionTypes.GET_DBIC_PDB_SUCCESS_IC:
      return {
        ...state,
        isDbicDoneBefore: true,
        dbicData: action.dbicData,
      };
    case actionTypes.GET_DBIC_PDB_FAILURE_IC:
      return {
        ...state,
        isDbicDoneBefore: false,
        dbicData: null,
      };
    case actionTypes.GET_IDVERSE_RESULTS_FAILURE_IC:
      return {
        ...state,
        expiredLinkMessage: action.message
          ? { type: "Error", info: { message: action.message } }
          : null,
        idverseResult: action.hasApiFailed ? true : false,
        dbicState: action.timestamp ? 'success' : (action.hasApiFailed ? 'failure' : state.dbicState),
        dbicData: action.timestamp ? (state.dbicData ? { ...state.dbicData, auditData: { ...state.dbicData?.auditData, timestamp: action.timestamp } } : state.dbicData) : state.dbicData,
      };
    case actionTypes.RESET_EXPIRED_LINK_MESSAGE_IC:
      return {
        ...state,
        expiredLinkMessage: null,
        idverseResult: false,
      };
    case actionTypes.START_POLLING_IC:
      return {
        ...state,
        dbicState: "pending",
        reuseFlow: true,
        pollTimeout: false,
      };
    case actionTypes.RESET_DBIC_STATUS_IC:
      return {
        ...state,
        dbicState: "",
        reuseFlow: false,
        pollTimeout: false,
      };
    case actionTypes.INITIATE_ATTEST_SUCCESS_IC:
      return {
        ...state,
        enableAttest: "success",
        reuseFlow: false,
      };
    case actionTypes.INITIATE_ATTEST_FAILURE_IC:
      return {
        ...state,
        enableAttest: "failure",
        reuseFlow: false,
      };
    default:
      return state;
  }
};

export default reducer;
